import React from "react";
import { OrdersContainer } from "./style";
import EmptyState from "components/emptyState";
import Button from "components/button";
const Orders = ({ orders, select }) => {
  return (
    <OrdersContainer>
      {orders.length ? (
        orders.map((order, index) => (
          <div className="items" key={index}>
            <div className="item">{order.title}</div>
            <div className="item">{order.status}</div>
            <div className="item">
              <Button title="ادامه" onClick={() => select(order)} />
            </div>
          </div>
        ))
      ) : (
        <EmptyState message="سفارشی  وجود ندارد" />
      )}
    </OrdersContainer>
  );
};
export default Orders;
